import { CALENDLY_URL } from 'src/constants/billing.constants';
import { useCurrentBilling } from 'src/hooks';

import {
  Container,
  TextContainer,
  CTAContainer,
  UpgradeButton,
} from './BillingUpgradeBusinessPlusBox.styles';

export const BillingUpgradeBusinessPlusBox = () => {
  const billing = useCurrentBilling();
  let text = 'You are currently in trial';
  if (billing?.isPro) text = 'You are currently on the Pro plan';
  if (billing?.isBusinessPlus) text = 'You are currently on the Business+ plan';
  return (
    <Container>
      <TextContainer>
        <p>{text}</p>
      </TextContainer>
      {!billing?.isBusinessPlus && (
        <CTAContainer>
          <UpgradeButton
            variant="primary"
            size="L"
            onClick={() => window.open(CALENDLY_URL, '_blank')}
          >
            Book demo
          </UpgradeButton>
        </CTAContainer>
      )}
    </Container>
  );
};
